export default __webpack_public_path__ + "static/media/business.5597517c.svg";